export async function callWithTimeout<T>(
  promise: Promise<T>,
  timeout: number,
  defaultResolve: T
): Promise<T> {
  let timer: ReturnType<typeof setTimeout> | undefined = undefined;

  const timerPromise = new Promise<T>(resolve => {
    timer = setTimeout(() => resolve(defaultResolve), timeout);
  });

  return Promise.race([
    promise.then(resolved => {
      if (timer) {
        clearTimeout(timer);
      }
      return resolved;
    }),
    timerPromise,
  ]);
}
